import { styled, Grid } from '@mui/material';
import React from 'react';
import { TABLET_SCREEN_SIZE, TABLET_HORIZONTAL_PADDING, MOBILE_SCREEN_SIZE, MOBILE_HORIZONTAL_PADDING, DESKTOP_SCREEN_SIZE, DESKTOP_HORIZONTAL_PADDING, WIDGET_MEDIA_BORDER_RADIUS } from '../../utils/constants/Constants.js';
import { GenericContainer, PreloadFonts } from '../components/GenericContainer.js';
import { BrandclubVideo } from '../components/BrandclubVideo.js';

var _a;
var HeaderContainer = styled(GenericContainer)((_a = {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: "0 5%",
        boxSizing: 'border-box',
        marginTop: 30
    },
    _a["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        marginTop: 0,
        backgroundColor: '#fff',
        padding: "20px ".concat(TABLET_HORIZONTAL_PADDING, "px"),
    },
    _a["@media screen and (max-width: ".concat(MOBILE_SCREEN_SIZE, "px)")] = {
        marginTop: 0,
        backgroundColor: '#fff',
        padding: "20px ".concat(MOBILE_HORIZONTAL_PADDING, "px"),
    },
    _a));
var HeaderDetails = styled('div')(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            zIndex: 1,
            fontFamily: 'Poppins',
            color: theme.palette.primary.main,
            padding: '0px 0px',
            boxSizing: 'border-box',
            maxWidth: 1000,
            // maxHeight: '80%',
            left: 0,
            textAlign: 'center',
            marginBottom: 25,
            '.title': {
                fontSize: 60,
                fontWeight: 'bold',
            },
            '.desc': {
                margin: '0',
                fontSize: 22,
                fontWeight: 500,
            }
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            marginBottom: 15,
            '.title': {
                textAlign: 'center',
                fontSize: 24,
                fontWeight: 'bold',
                width: '100%',
            },
            '.desc': {
                textAlign: 'center',
                paddingTop: 5,
                margin: '',
                fontSize: 16,
                fontWeight: 500,
                width: '100%',
            },
        },
        _b);
});
var HeroContainer = styled(Grid)({
    flexDirection: 'column',
    maxWidth: DESKTOP_SCREEN_SIZE - DESKTOP_HORIZONTAL_PADDING * 2,
    width: '100%',
    position: 'relative',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    '.headerImage': {
        // aspectRatio: '5/1',
        borderRadius: WIDGET_MEDIA_BORDER_RADIUS,
        overflow: 'hidden',
        objectFit: 'cover',
        width: '100%',
    },
});
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var BrandHeaderWithVideo = function (_a) {
    var _b = _a.headerVideo, headerVideo = _b === void 0 ? '' : _b, _c = _a.coverImage, coverImage = _c === void 0 ? '' : _c, _d = _a.title, title = _d === void 0 ? '' : _d, _e = _a.subtitle, subtitle = _e === void 0 ? '' : _e;
    return (React.createElement(HeaderContainer, null,
        React.createElement(PreloadFonts, null),
        React.createElement(HeroContainer, null,
            React.createElement(HeaderDetails, null,
                title ? React.createElement("div", { className: "title" }, title) : null,
                subtitle ? React.createElement("div", { className: "desc" }, subtitle) : null),
            React.createElement(BrandclubVideo, { videoUrl: headerVideo, posterUrl: coverImage }))));
};

export { BrandHeaderWithVideo };
//# sourceMappingURL=index.js.map
